/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * a Risk override reason
 * @export
 * @interface InternalApiFinalRiskOverrideReason
 */
export interface InternalApiFinalRiskOverrideReason {
    /**
     * 
     * @type {string}
     * @memberof InternalApiFinalRiskOverrideReason
     */
    handle: string;
    /**
     * a Final risk override reason
     * @type {string}
     * @memberof InternalApiFinalRiskOverrideReason
     */
    reason: string;
    /**
     * a Final risk override reason description
     * @type {string}
     * @memberof InternalApiFinalRiskOverrideReason
     */
    description: string;
}

/**
 * Check if a given object implements the InternalApiFinalRiskOverrideReason interface.
 */
export function instanceOfInternalApiFinalRiskOverrideReason(value: object): value is InternalApiFinalRiskOverrideReason {
    if (!('handle' in value) || value['handle'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function InternalApiFinalRiskOverrideReasonFromJSON(json: any): InternalApiFinalRiskOverrideReason {
    return InternalApiFinalRiskOverrideReasonFromJSONTyped(json, false);
}

export function InternalApiFinalRiskOverrideReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiFinalRiskOverrideReason {
    if (json == null) {
        return json;
    }
    return {
        
        'handle': json['handle'],
        'reason': json['reason'],
        'description': json['description'],
    };
}

export function InternalApiFinalRiskOverrideReasonToJSON(json: any): InternalApiFinalRiskOverrideReason {
    return InternalApiFinalRiskOverrideReasonToJSONTyped(json, false);
}

export function InternalApiFinalRiskOverrideReasonToJSONTyped(value?: InternalApiFinalRiskOverrideReason | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'handle': value['handle'],
        'reason': value['reason'],
        'description': value['description'],
    };
}

